import Err404 from '../components/common/404/404';

export default function Custom404() {
    return <Err404 />
}